const mapStateToProps = state => 
    ({
        dataRegistered: state.solicitudEmpadronamientoExtranjero.dataRegistered,
        step: state.solicitudEmpadronamientoExtranjero.step,
        datosSolicitudExtranjero: state.solicitudEmpadronamientoExtranjero.datosSolicitudExtranjero,
        datosResidencia: state.solicitudEmpadronamientoExtranjero.datosResidencia,
        ArrayListado: state.solicitudEmpadronamientoExtranjero.ArrayListado,
        catalogos: state.solicitudEmpadronamientoExtranjero.catalogos,
        nroBoleta: state.solicitudEmpadronamientoExtranjero.nroBoleta,
        datoIdentidadFotoIngresada: state.solicitudEmpadronamientoExtranjero.datoIdentidadFotoIngresada,
        esPadronRenap: state.solicitudEmpadronamientoExtranjero.esPadronRenap,
        currentUser: state.security.currentUser,
        datosSolicitudGeneradoNancional: state.solicitudEmpadronamientoExtranjero.datosSolicitudGeneradoNancional,
    });
export default mapStateToProps;
